export default __webpack_public_path__ + "static/media/trialOver.9c0b99f8.svg";